const Spinner = () => <div className='spinner_wrapper' data-sentry-component="Spinner" data-sentry-source-file="Spinner.tsx">
    <span className='spinner_element'>Loading...</span>
  </div>;
export default Spinner;